import { TimelineLite, Power2 } from 'gsap'
import bus from './bus'
import UI from './utils/UI'

UI({
  component: '.js-frontPage',
  payoff: '.js-frontPage-payoff',
  content: '.js-frontPage-content'
}, ({ component, payoff, content }) => {
  const tl = new TimelineLite({ onComplete: _ => bus.emit('front-page-ready'), paused: true })
  tl.to(payoff, 0.25, { opacity: 0.8, ease: Power2.easeInOut })
  tl.to(content, 0.25, { opacity: 1, ease: Power2.easeInOut }, 0.1)
  bus.on('shapes-bg-ready', _ => { tl.paused(false) })
})
